import { Row, Col, Button } from 'react-bootstrap';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './RegisterSuccess.css';

const RegisterSuccess = ({onToConsent}) => {
  return (
    <Row className='register-success-container'>
      <Col className='text-start'>
        <h2>Tu datos están listos.👌</h2>
        <h2>
          Ahora sólo te queda firmar el Consentimiento Informado.
        </h2>
        <div className="register-footer-row">
          <Button variant='primary'
            onClick={() =>  onToConsent()}
          >Continuar</Button>
        </div>
      </Col>
    </Row>
  );
}

export default RegisterSuccess;